(function () {
  "use strict";
  var RM = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var JR = window.JR || { routes: {}, moneyFormat: "{{amount}} TL" };

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var value = (cents / 100);
    var fmt = JR.moneyFormat || "{{amount}} TL";
    function withCommas(num, decimals) {
      var parts = num.toFixed(decimals).split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return decimals ? parts[0] + "," + parts[1] : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, name) {
      switch (name) {
        case "amount": return withCommas(value, 2);
        case "amount_no_decimals": return withCommas(value, 0);
        case "amount_with_comma_separator": return value.toFixed(2).replace(".", ",");
        case "amount_no_decimals_with_comma_separator": return withCommas(value, 0);
        default: return withCommas(value, 2);
      }
    });
  }

  /* ---------- ready / hero ---------- */
  function markReady() { requestAnimationFrame(function () { document.body.classList.add("jr-ready"); }); }
  if (document.readyState === "complete") markReady();
  else window.addEventListener("load", markReady);

  /* ---------- nav scroll ---------- */
  var nav = document.querySelector(".nav");
  if (nav) {
    var onScroll = function () { nav.classList.toggle("scrolled", window.pageYOffset > 12); };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---------- mobile menu ---------- */
  var menuBtn = document.getElementById("jrMenuBtn");
  var menuPanel = document.getElementById("jrMenuPanel");
  if (menuBtn && menuPanel) {
    menuBtn.addEventListener("click", function () {
      var open = menuPanel.classList.toggle("open");
      menuBtn.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  /* ---------- reveal ---------- */
  if (!RM && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); }
      });
    }, { rootMargin: "0px 0px -8% 0px" });
    document.querySelectorAll(".reveal").forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll(".reveal").forEach(function (el) { el.classList.add("in"); });
  }

  /* ---------- theme toggle ---------- */
  var root = document.documentElement;
  var order = ["system", "light", "dark"];
  var names = { system: "Sistem", light: "Aydınlık", dark: "Karanlık" };
  var cur = "system";
  try { var t = localStorage.getItem("jr-theme"); if (t) cur = t; } catch (e) {}
  function applyTheme() {
    if (cur === "system") root.removeAttribute("data-theme");
    else root.setAttribute("data-theme", cur);
    document.querySelectorAll("[data-theme-label]").forEach(function (el) { el.textContent = names[cur]; });
    try { localStorage.setItem("jr-theme", cur); } catch (e) {}
  }
  function cycleTheme() { cur = order[(order.indexOf(cur) + 1) % order.length]; applyTheme(); }
  applyTheme();
  document.querySelectorAll("[data-theme-toggle]").forEach(function (el) { el.addEventListener("click", cycleTheme); });

  /* ---------- cart drawer ---------- */
  var drawer = document.getElementById("jrDrawer");
  var scrim = document.getElementById("jrScrim");
  var itemsEl = document.getElementById("jrDrawerItems");
  var footEl = document.getElementById("jrDrawerFoot");
  var counts = document.querySelectorAll("[data-cart-count]");

  function setCounts(n) { counts.forEach(function (el) { el.textContent = "(" + n + ")"; }); }

  function openDrawer() {
    drawer.hidden = false; scrim.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add("show"); scrim.classList.add("show"); });
    var c = document.getElementById("jrDrawerClose"); if (c) c.focus();
  }
  function closeDrawer() {
    drawer.classList.remove("show"); scrim.classList.remove("show");
    setTimeout(function () { drawer.hidden = true; scrim.hidden = true; }, 420);
  }
  var dc = document.getElementById("jrDrawerClose");
  if (dc) dc.addEventListener("click", closeDrawer);
  if (scrim) scrim.addEventListener("click", closeDrawer);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && drawer && !drawer.hidden) closeDrawer(); });
  document.querySelectorAll("[data-cart-open]").forEach(function (el) {
    el.addEventListener("click", function (e) { e.preventDefault(); refreshCart().then(openDrawer); });
  });

  function renderCart(cart) {
    if (!itemsEl) return;
    setCounts(cart.item_count);
    if (!cart.items.length) {
      itemsEl.innerHTML = '<p class="empty">Sepetiniz boş.</p>';
      footEl.innerHTML = "";
      return;
    }
    var saved = 0;
    itemsEl.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, "_120x$1$2") : "";
      var size = it.variant_title && it.variant_title !== "Default Title" ? "Beden " + it.variant_title : "";
      var was = 0;
      if (it.original_line_price && it.original_line_price > it.final_line_price) {
        was = it.original_line_price;
      } else if (it.compare_at_price && it.compare_at_price > it.final_price) {
        was = it.compare_at_price * it.quantity;
      }
      if (was) saved += (was - it.final_line_price);
      var lp = (was ? '<span class="was">' + formatMoney(was) + '</span>' : '') + formatMoney(it.final_line_price);
      return '<div class="line">' +
        '<a class="sw" href="' + it.url + '" style="background-image:url(' + img + ')" aria-label="' + it.title + '"></a>' +
        '<span><span class="ln">' + it.product_title + '</span>' +
        (size ? '<span class="ls">' + size + '</span>' : '') +
        '<button class="rm" data-key="' + it.key + '">Çıkar</button></span>' +
        '<span class="lp">' + lp + '</span>' +
        '</div>';
    }).join("");
    footEl.innerHTML =
      (saved > 0 ? '<div class="subtotal saved"><span>İndirim</span><span class="v">− ' + formatMoney(saved) + '</span></div>' : '') +
      '<div class="subtotal"><span>Ara Toplam</span><span class="v">' + formatMoney(cart.total_price) + '</span></div>' +
      '<a class="checkout" href="' + (JR.routes.checkout || "/checkout") + '">Ödemeye Geç</a>' +
      '<p class="co-note">Kargo ödeme adımında hesaplanır. Ödeme iyzico güvencesiyle alınır.</p>';
  }

  function refreshCart() {
    return fetch(JR.routes.cart ? JR.routes.cart + ".js" : "/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function () {});
  }

  if (itemsEl) {
    itemsEl.addEventListener("click", function (e) {
      var b = e.target.closest("[data-key]"); if (!b) return;
      fetch((JR.routes.cart_change || "/cart/change") + ".js", {
        method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: b.getAttribute("data-key"), quantity: 0 })
      }).then(function (r) { return r.json(); }).then(renderCart);
    });
  }

  function addToCart(formData) {
    return fetch((JR.routes.cart_add || "/cart/add") + ".js", {
      method: "POST", headers: { "Accept": "application/json" }, body: formData
    }).then(function (r) { return r.json(); })
      .then(function () { return refreshCart(); })
      .then(function () { openDrawer(); });
  }

  /* ---------- product form ---------- */
  var pform = document.getElementById("jrProductForm");
  if (pform) {
    var variants = [];
    try { variants = JSON.parse(document.getElementById("jrVariantData").textContent); } catch (e) {}
    var idInput = pform.querySelector('input[name="id"]');
    var addBtn = pform.querySelector(".add");
    var buyBtn = pform.querySelector(".buy-now");
    var sizeWrap = pform.querySelector(".sizes");
    var mainImg = document.getElementById("jrPdpMain");
    var chosen = null;

    function pickVariant(value) {
      var v = variants.filter(function (x) { return x.option1 === value; })[0];
      if (!v) return;
      chosen = v;
      idInput.value = v.id;
      addBtn.removeAttribute("disabled");
      addBtn.textContent = "Sepete Ekle";
      if (buyBtn) buyBtn.removeAttribute("disabled");
      if (v.featured_image && mainImg) mainImg.src = v.featured_image;
    }

    if (buyBtn) {
      buyBtn.addEventListener("click", function () {
        if (!chosen) { if (sizeWrap) sizeWrap.classList.add("warn"); return; }
        buyBtn.textContent = "Yönlendiriliyor…";
        fetch((JR.routes.cart_add || "/cart/add") + ".js", {
          method: "POST", headers: { "Accept": "application/json" }, body: new FormData(pform)
        }).then(function () { window.location.href = JR.routes.checkout || "/checkout"; })
          .catch(function () { window.location.href = JR.routes.checkout || "/checkout"; });
      });
    }
    if (sizeWrap) {
      sizeWrap.addEventListener("click", function (e) {
        var btn = e.target.closest("button"); if (!btn || btn.disabled) return;
        sizeWrap.querySelectorAll("button").forEach(function (x) { x.setAttribute("aria-pressed", "false"); });
        btn.setAttribute("aria-pressed", "true");
        sizeWrap.classList.remove("warn");
        pickVariant(btn.dataset.value);
      });
    }
    pform.addEventListener("submit", function (e) {
      e.preventDefault();
      if (!chosen) { if (sizeWrap) sizeWrap.classList.add("warn"); return; }
      addBtn.textContent = "Ekleniyor…";
      addToCart(new FormData(pform)).then(function () { addBtn.textContent = "Sepete Eklendi"; });
    });

    var thumbs = document.getElementById("jrPdpThumbs");
    if (thumbs && mainImg) {
      thumbs.addEventListener("click", function (e) {
        var t = e.target.closest("button"); if (!t) return;
        mainImg.src = t.dataset.src;
        thumbs.querySelectorAll("button").forEach(function (x) { x.setAttribute("aria-current", "false"); });
        t.setAttribute("aria-current", "true");
      });
    }

    /* mobile swipe gallery — pagination dots */
    var gallery = document.querySelector(".pdp-gallery");
    if (gallery) {
      var gimgs = gallery.querySelectorAll("img");
      if (gimgs.length > 1) {
        var dots = document.createElement("div");
        dots.className = "pdp-dots";
        for (var gi = 0; gi < gimgs.length; gi++) dots.appendChild(document.createElement("i"));
        gallery.parentNode.insertBefore(dots, gallery.nextSibling);
        var dotEls = dots.querySelectorAll("i");
        dotEls[0].classList.add("on");
        var draf;
        gallery.addEventListener("scroll", function () {
          if (draf) return;
          draf = requestAnimationFrame(function () {
            draf = null;
            var idx = Math.round(gallery.scrollLeft / gallery.clientWidth);
            for (var k = 0; k < dotEls.length; k++) dotEls[k].classList.toggle("on", k === idx);
          });
        }, { passive: true });
      }
    }

    /* mobile sticky add-to-cart bar */
    var sticky = document.getElementById("jrPdpSticky");
    var stickyAdd = document.getElementById("jrStickyAdd");
    if (sticky && stickyAdd && addBtn) {
      if ("IntersectionObserver" in window) {
        new IntersectionObserver(function (entries) {
          var en = entries[0];
          sticky.classList.toggle("show", !en.isIntersecting);
          sticky.setAttribute("aria-hidden", en.isIntersecting ? "true" : "false");
        }, { rootMargin: "0px 0px -40px 0px" }).observe(addBtn);
      }
      stickyAdd.addEventListener("click", function () {
        if (!chosen) {
          if (sizeWrap) {
            sizeWrap.classList.add("warn");
            sizeWrap.scrollIntoView({ behavior: "smooth", block: "center" });
          }
          return;
        }
        stickyAdd.textContent = "Ekleniyor…";
        addToCart(new FormData(pform)).then(function () {
          stickyAdd.textContent = "Sepete Eklendi";
          setTimeout(function () { stickyAdd.textContent = "Sepete Ekle"; }, 1800);
        });
      });
    }
  }

  /* ---------- homepage product row (Incotex-style) ---------- */
  document.querySelectorAll(".prow").forEach(function (row) {
    var track = row.querySelector(".prow-track");
    var countEl = row.querySelector(".prow-count");
    var prev = row.querySelector(".prow-prev");
    var next = row.querySelector(".prow-next");
    if (!track) return;
    function pageCount() { return Math.max(1, Math.ceil((track.scrollWidth - 2) / track.clientWidth)); }
    function curPage() { return Math.round(track.scrollLeft / track.clientWidth) + 1; }
    function render() {
      var pc = pageCount();
      if (countEl) countEl.textContent = Math.min(curPage(), pc) + " / " + pc;
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    function go(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: "smooth" }); }
    if (prev) prev.addEventListener("click", function () { go(-1); });
    if (next) next.addEventListener("click", function () { go(1); });
    var praf;
    track.addEventListener("scroll", function () {
      if (praf) return;
      praf = requestAnimationFrame(function () { praf = null; render(); });
    }, { passive: true });
    window.addEventListener("resize", render);
    render();
  });

  /* quick-add from product cards (optional data-quick-add with variant id) */
  document.querySelectorAll("[data-quick-add]").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      var fd = new FormData();
      fd.append("id", btn.getAttribute("data-quick-add"));
      fd.append("quantity", "1");
      addToCart(fd);
    });
  });

  refreshCart();
})();
